import React from 'react';

import Header from './styles';

export default function Greeting() {
  return (
    <Header>
      <h1>Olá!</h1>
    </Header>
  );
}
